/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { keyframes, ThemeProvider } from '@mui/material/styles';
import { theme } from '../../theme';
import HeaderProfile from '../../components/header_Profile/header_Profile.index';
import OocyteRetrieval from '../../components/Surgery/oocyteRetrieval';
import EmbryoTransfer from '../../components/Surgery/embryoTransfer';
import { ReactComponent as UterusIcon } from '../../assets/SVG/uterus1.svg';
import { IconButton,Tooltip } from '@mui/material';
import { ReactComponent as EmbryoIcon } from '../../assets/SVG/embryo1.svg';
import { ReactComponent as LaparoscopyIcon } from '../../assets/SVG/laparoscopy1.svg';
import { ReactComponent as HysteroscopyIcon } from '../../assets/SVG/hysteroscopy1.svg';
import { ReactComponent as SpermRetrievalIcon } from '../../assets/SVG/sperm1.svg';
import { usePatientContext } from '../../components/patinetProvider';
import { fetchMasterData, getARTCycleList } from '../../components/Surgery/oocyteRetrieval/OocyteRetrival.helper';
import { useLoader } from '../../components/loaderProvider/loader';
import CyclesUnavailable from '../../components/Surgery/cyclesUnavailable';
import LaparoscopyContainer from '../../components/Surgery/laparoscopy/LaparoscopyContainer';
import HystereoscopyContainer from '../../components/Surgery/hysteroscopy/hysteroscopyContainer';
import SurgicalSpermRetrievalContainer from '../../components/Surgery/surgicalSpermRetrieval/surgicalSpermRetrievalContainer';
import { usePatientContext as useSubPatientContext } from '../../components/SubPatinetProvider';
import { ReactComponent as PrinterIcon } from '../../assets/SVG/printer (1).svg';
import OocyteRetrievalPDFDialog from '../Registration/NewRegistration/PatientPartnerRegistration/PatientReport/OocyteRetrievalPDFDialog';
import EmbryoTransferPDFDialog from '../Registration/NewRegistration/PatientPartnerRegistration/PatientReport/EmbryoTransferPDFDialog';
import { DropdownOption, mapDropdownOptions } from '../../components/Medical_History_Forms/MenstrualHistory/MenstrualHistory.helpers';
import { getStoredPermissions } from '../../utils/commonUtils';
import NoAccessPage from '../noAccessPage';



interface PatientData {
  id: number;
  gender: 'MALE' | 'FEMALE';
  age: number;
  nameTitle: string;
  firstName: string;
  lastName: string;
  cycleNo: string;
  mrNo: string;
  updatedDatetime: Date;
  LastModified: string;
  visitID: string;
  genderId: string;
  visitedDoctorID: string;
  therapyId: string;
};

const SurgeryPage: React.FC = () => {
  const { t: tGeneral } = useTranslation('general');
  const { t: tSurgery } = useTranslation('surgery_config');
  const [selectedPatient, setSelectedPatient] = useState<PatientData | null>(null);
  const [selectedProcedure, setSelectedProcedure] = useState<string |null>(null);

  const { patientId } = usePatientContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [cycleExists, setCycleExists] = useState(false);
  const { showLoader, hideLoader } = useLoader();
  const { patientId: selected_PID } = useSubPatientContext();
  const [openPreview, setOpenPreview] = useState(false);
  const [isSurgeryRecordSaved, setIsSurgeryRecordSaved] = useState(false);
  const [dropdownOptionsForSurgery, setDropdownOptionsForSurgery] = useState<{
    type_of_anesthesia: DropdownOption[];
    type_of_needle: DropdownOption[];
    sub_type_of_needle: DropdownOption[];
    difficulty_level: DropdownOption[];
    transfer_method: DropdownOption[];
    embryo_Anesthesia: DropdownOption[];
    endometrium_pattern: DropdownOption[];
    ultrasound_method: DropdownOption[];
    catheter: DropdownOption[];
    embryoDifficulty_level: DropdownOption[];
    Laparo_anesthesia_type: DropdownOption[];
    adhesion_grade: DropdownOption[];
    endometriosis_grade: DropdownOption[];
    uterus_status: DropdownOption[];
    uterus_size: DropdownOption[];
    uterus_mobility: DropdownOption[];
    associated_procedures: DropdownOption[];
    liver_undersurface: DropdownOption[];
    cavity:DropdownOption[],
    endometrium_patterns: DropdownOption[],
    procedure_done: DropdownOption[],

  }>({
    type_of_anesthesia: [],
    type_of_needle: [],
    sub_type_of_needle: [],
    difficulty_level: [],
    transfer_method: [],
    embryo_Anesthesia: [],
    endometrium_pattern: [],
    ultrasound_method: [],
    catheter: [],
    embryoDifficulty_level: [],
    Laparo_anesthesia_type: [],
    adhesion_grade: [],
    endometriosis_grade: [],
    uterus_status: [],
    uterus_size: [],
    uterus_mobility: [],
    associated_procedures: [],
    liver_undersurface: [],
    cavity: [],
    endometrium_patterns: [],
    procedure_done: [],

  });

  const allowedSurgeryModule = React.useMemo(() => {
    
    const permissionsData = getStoredPermissions();
    const clinicalModule = permissionsData?.modules?.find(
      (m: any) => m.name === 'Clinical' && m.featureEnabled
    );
    if (!clinicalModule) return { type: [] };
    const SurgeryModule = clinicalModule.submodules?.find(
      (sm: any) => sm.name === 'Surgery'
    );
    return SurgeryModule || { type: [] };
  }, []);
  const handleDatafromHeader = useCallback((data: PatientData) => {
    setSelectedPatient((prev) => {
      if (!prev || prev.id !== data.id) {
        return data;
      }
      return prev;
    });
  }, []);
  
  const handleSurgeryRecordSaved = useCallback((saved: boolean) => {
    setIsSurgeryRecordSaved(saved);
  }, []);
  const redirectToProcedure = useCallback((procedureType: string) => {
    if (!selectedPatient) return;
    navigate(`/clinical/patients/surgery/${patientId}?surgeryType=${procedureType}`);
  }, [navigate, patientId, selectedPatient]);

  const determineProcedureOnQuery = useCallback(() => {
    const searchParams = new URLSearchParams(location.search);
    const surgeryType = searchParams.get('surgeryType');

    if (!selectedPatient) return;

    if (!surgeryType) {
      if (selectedPatient.gender === 'MALE') {
        setSelectedProcedure('SurgicalSpermRetrieval');
        redirectToProcedure('SurgicalSpermRetrieval');
      } else if (selectedPatient.gender === 'FEMALE') {
        if (Array.isArray(allowedSurgeryModule.type)) {
          const order = ['OocyteRetrieval', 'EmbryoTransfer', 'Hysteroscopy', 'Laparoscopy'];
          const availableProcedures = allowedSurgeryModule.type
            .filter((proc: any) => proc.name !== 'Surgical Sperm Retrieval' && proc.featureEnabled && proc.female)
            .map((proc: any) => proc.name.replace(/\s/g, ''));
          const sortedProcedures = order.filter(name => availableProcedures.includes(name));
          if (sortedProcedures.length > 0) {
            setSelectedProcedure(sortedProcedures[0]);
            redirectToProcedure(sortedProcedures[0]);
          } else {
            setSelectedProcedure(null);
          }
        } else {
          setSelectedProcedure(null);
        }
      }
      return;
    }

    if (selectedPatient) {
      if (selectedPatient.gender === 'MALE') {
        setSelectedProcedure('SurgicalSpermRetrieval');
        redirectToProcedure('SurgicalSpermRetrieval');
      } else if (selectedPatient.gender === 'FEMALE') {
        if (surgeryType === 'SurgicalSpermRetrieval') {
          if (Array.isArray(allowedSurgeryModule.type)) {
            const order = ['OocyteRetrieval', 'EmbryoTransfer', 'Hysteroscopy', 'Laparoscopy'];
            const availableProcedures = allowedSurgeryModule.type
              .filter((proc: any) => proc.name !== 'Surgical Sperm Retrieval' && proc.featureEnabled && proc.female)
              .map((proc: any) => proc.name.replace(/\s/g, ''));
            const sortedProcedures = order.filter(name => availableProcedures.includes(name));
            
            if (sortedProcedures.length > 0) {
              setSelectedProcedure(sortedProcedures[0]);
              redirectToProcedure(sortedProcedures[0]);
            }
          }
        } else {
          if (!surgeryType) {
            const order = ['OocyteRetrieval', 'EmbryoTransfer', 'Hysteroscopy', 'Laparoscopy'];
             
            const availableProcedures = allowedSurgeryModule.type
              .filter((proc: any) => proc.name !== 'Surgical Sperm Retrieval' && proc.featureEnabled && proc.female)
              .map((proc: any) => proc.name.replace(/\s/g, ''));
            const sortedProcedures = order.filter(name => availableProcedures.includes(name));
            if (sortedProcedures.length > 0) {
              setSelectedProcedure(sortedProcedures[0]);
              redirectToProcedure(sortedProcedures[0]);
            }
            else{
              setSelectedProcedure(null);
            }
          } 
          else{
            setSelectedProcedure(surgeryType);
            redirectToProcedure(surgeryType);
          }

        }
      }
    }
  }, [location.search, selectedPatient, redirectToProcedure, allowedSurgeryModule]);

  useEffect(() => {
    fetchMasterData(
      '' 
    )
      .then((response) => {
        setDropdownOptionsForSurgery({
          type_of_anesthesia: mapDropdownOptions(response?.OOCYTE_ANESTHESIA),
          type_of_needle: mapDropdownOptions(response?.NEEDLE),
          sub_type_of_needle: mapDropdownOptions(response?.NEEDLE_SUBTYPE),
          difficulty_level: mapDropdownOptions(response?.DIFFICULTY),
          transfer_method: mapDropdownOptions(response?.TRANSFER_METHOD),
          embryo_Anesthesia: mapDropdownOptions(response?.EMBRYO_ANESTHESIA),
          endometrium_pattern: mapDropdownOptions(response?.EEMBRYO_NDOMETRIUM_PATTERN),
          ultrasound_method: mapDropdownOptions(response?.ULTRASOUND_METHOD),
          catheter: mapDropdownOptions(response?.CATHETER),
          embryoDifficulty_level: mapDropdownOptions(response?.LEVEL_OF_DIFFICULTY),
          Laparo_anesthesia_type: mapDropdownOptions(response?.LAPARO_ANESTHESIA),
          adhesion_grade: mapDropdownOptions(response?.ADHESION_GRADE),
          endometriosis_grade: mapDropdownOptions(response?.ENDOMETRIOSIS_GRADE),
          uterus_status: mapDropdownOptions(response?.UTERUS_STATUS),
          uterus_size: mapDropdownOptions(response?.UTERUS_SIZE),
          uterus_mobility: mapDropdownOptions(response?.UTERUS_MOBILITY),
          associated_procedures: mapDropdownOptions(response?.ASSOCIATED_PROCEDURES),
          liver_undersurface: mapDropdownOptions(response?.LIVER_STATUS),
          cavity: mapDropdownOptions(response?.CAVITY),
          endometrium_patterns: mapDropdownOptions(response?.ENDOMETRIUM_PATTERN),
          procedure_done: mapDropdownOptions(response?.PROCEDURE_DONE),



        });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Error fetching medical history masters', err);
      });
  }, []);

  useEffect(() => {
    determineProcedureOnQuery();
  }, [location.search, selectedPatient, determineProcedureOnQuery]);
  const handleProcedureSelect = useCallback((procedure: string) => {
    setSelectedProcedure(procedure);
    setIsSurgeryRecordSaved(false); // Reset when changing procedures
    redirectToProcedure(procedure);
  }, [redirectToProcedure]);

  useEffect(() => {
    showLoader();
    setCycleExists(false); 

    getARTCycleList(selected_PID)
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setCycleExists(true);
        } else {
          setCycleExists(false);
        }
      })
      .catch(() => {
        setCycleExists(false);
      })
      .finally(() => {
        hideLoader();
      });
  }, [selected_PID, selectedPatient, showLoader, hideLoader]);


 

  const procedures = useMemo(() => {
    if (!selectedPatient || !Array.isArray(allowedSurgeryModule.type)) {
      setSelectedProcedure(null);
      return [];
    }

    const procedureMeta: Record<string, { label: string; icon: JSX.Element }> = {
      'Oocyte Retrieval': { label: tSurgery('oocyteRetrieval'), icon: <UterusIcon /> },
      'Embryo Transfer': { label: tSurgery('embryoTransfer'), icon: <EmbryoIcon /> },
      'Laparoscopy': { label: tSurgery('laparoscopy'), icon: <LaparoscopyIcon /> },
      'Hysteroscopy': { label: tSurgery('hysteroscopy'), icon: <HysteroscopyIcon /> },
      'Surgical Sperm Retrieval': { label: tSurgery('surgicalSpermRetrieval'), icon: <SpermRetrievalIcon /> },
    };

    if (selectedPatient.gender === 'MALE') {
      return allowedSurgeryModule.type
        .filter((proc: any) => proc.name === 'Surgical Sperm Retrieval' && proc.featureEnabled && proc.male)
        .map((proc: any) => {
          const meta = procedureMeta[proc.name];
          if (!meta) return null;
          return {
            name: proc.name.replace(/\s/g, ''),
            label: meta.label,
            icon: meta.icon,
          };
        })
        .filter(Boolean);
    }

    return allowedSurgeryModule.type
      .filter((proc: any) => proc.name !== 'Surgical Sperm Retrieval' && proc.featureEnabled && proc.female)
      .map((proc: any) => {
        const meta = procedureMeta[proc.name];
        if (!meta) return null;
        return {
          name: proc.name.replace(/\s/g, ''),
          label: meta.label,
          icon: meta.icon,
        };
      })
      .filter(Boolean);
  }, [selectedPatient, allowedSurgeryModule, tSurgery]);
 
  const renderProcedureForm = useMemo(() => {
    if (!selectedPatient) return <p>{tGeneral('noPatientSelected')}</p>;

    if (
      !cycleExists &&
      ['OocyteRetrieval', 'EmbryoTransfer'].includes(selectedProcedure ?? '')
    ) {
      return <CyclesUnavailable />;
    }

    if (selectedProcedure === 'SurgicalSpermRetrieval') {
      
      const isAvailable = procedures.some((p:any) => p.name === 'SurgicalSpermRetrieval');
      
      if (isAvailable) {
        const permObj = Array.isArray(allowedSurgeryModule.type)
          ? allowedSurgeryModule.type.find((proc: any) => proc.name.replace(/\s/g, '') === 'SurgicalSpermRetrieval')
          : undefined;
        return <SurgicalSpermRetrievalContainer permissions={permObj?.permissions ?? []} />;
      }
    }

    switch (selectedProcedure) {
    case 'OocyteRetrieval': {
      const permObj = Array.isArray(allowedSurgeryModule.type)
        ? allowedSurgeryModule.type.find((proc: any) => proc.name.replace(/\s/g, '') === 'OocyteRetrieval')
        : undefined;
      return <OocyteRetrieval dropDownOptions={dropdownOptionsForSurgery} permissions={permObj?.permissions ?? []} onRecordSaved={handleSurgeryRecordSaved} />;
    }
    case 'EmbryoTransfer': {
      const permObj = Array.isArray(allowedSurgeryModule.type)
        ? allowedSurgeryModule.type.find((proc: any) => proc.name.replace(/\s/g, '') === 'EmbryoTransfer')
        : undefined;
      return <EmbryoTransfer dropDownOptions={dropdownOptionsForSurgery} permissions={permObj?.permissions ?? []} onRecordSaved={handleSurgeryRecordSaved} />;
    }
    case 'Laparoscopy': {
      const permObj = Array.isArray(allowedSurgeryModule.type)
        ? allowedSurgeryModule.type.find((proc: any) => proc.name.replace(/\s/g, '') === 'Laparoscopy')
        : undefined;
      return <LaparoscopyContainer dropDownOptions={dropdownOptionsForSurgery} permissions={permObj?.permissions ?? []} />;
    }
    case 'Hysteroscopy': {
      const permObj = Array.isArray(allowedSurgeryModule.type)
        ? allowedSurgeryModule.type.find((proc: any) => proc.name.replace(/\s/g, '') === 'Hysteroscopy')
        : undefined;
      return <HystereoscopyContainer dropDownOptions={dropdownOptionsForSurgery} permissions={permObj?.permissions ?? []} />;
    }
    default:
      return <p></p>;
    }
  }, [selectedPatient, selectedProcedure, cycleExists,dropdownOptionsForSurgery, allowedSurgeryModule.type, procedures, tGeneral, handleSurgeryRecordSaved]);

  const borderAnimation = keyframes`
  0% {
    border-color: rgba(235, 235, 235, 1);
    border-width: 1px;
    box-shadow: 0 0 3px rgba(255, 126, 0, 0.8), 0 0 10px rgba(255, 126, 0, 0.6);
  }
`;


  const buttonStyles = useMemo(() => ({
    base: {
      border: '1px solid rgba(235, 235, 235, 1)',
      backgroundColor: 'rgba(250, 250, 250, 1)',
      boxShadow: 'none',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      color: 'rgba(193, 193, 193, 1)',
      '&:hover': {
        backgroundColor: 'rgba(255, 248, 246, 1)',
        boxShadow: '2px 2px 12px 0px rgba(0, 0, 0, 0.15)',
      }
    },
    selected: {
      border: '1px solid rgba(225, 126, 97, 1)',
      backgroundColor: 'rgba(255, 248, 246, 1)',
      boxShadow: '2px 2px 8px 0px rgba(0, 0, 0, 0.12)',
      color: 'rgba(225, 126, 97, 1)',
      fontWeight: 600,
      animation: `${borderAnimation} 5s ease-in-out `,
    }
  }), [borderAnimation]);


  return (
    <ThemeProvider theme={theme}>
      <div>
        <HeaderProfile onData={handleDatafromHeader} />

        {procedures.length > 0 ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: 4,
              marginLeft: 3,
              marginRight: 3, 
            }}
          >
            <Box sx={{ display: 'flex', gap: 2 }}>
              {(() => {
                let sortedProcedures = procedures;
                if (selectedPatient?.gender === 'FEMALE') {
                  const order = ['OocyteRetrieval', 'EmbryoTransfer', 'Hysteroscopy', 'Laparoscopy'];
                  sortedProcedures = order
                    .map(name => procedures.find((p: { name: string; }) => p.name === name))
                    .filter(Boolean) as typeof procedures;

                }
                return sortedProcedures.map((procedure: any) => (
                  <Button
                    key={procedure.name}
                    variant="contained"
                    onClick={() => handleProcedureSelect(procedure.name)}
                    sx={{
                      ...buttonStyles.base,
                      ...(selectedProcedure === procedure.name && buttonStyles.selected),
                    }}
                    startIcon={procedure.icon}
                  >
                    {procedure.label}
                  </Button>
                ));
              })()}
            </Box>

            {(() => {
              if (selectedProcedure === 'OocyteRetrieval' || selectedProcedure === 'EmbryoTransfer') {
                const procObj = Array.isArray(allowedSurgeryModule.type)
                  ? allowedSurgeryModule.type.find((proc: any) => proc.name.replace(/\s/g, '') === selectedProcedure)
                  : undefined;
                if (procObj && Array.isArray(procObj.permissions)) {
                  const hasPrintAccess = procObj.permissions.some((perm: any) =>
                    perm.access === 'print' && perm[selectedPatient?.gender?.toLowerCase() || 'female']
                  );
                  if (hasPrintAccess && isSurgeryRecordSaved) {
                    return (
                      <Tooltip title="Print Report">
                        <IconButton onClick={() => setOpenPreview(true)}>
                          <PrinterIcon />
                        </IconButton>
                      </Tooltip>
                    );
                  }
                }
              }
              return null;
            })()}

          </Box>
        ):(
          <NoAccessPage />
        )}


        {selectedProcedure === 'OocyteRetrieval' && (
          <OocyteRetrievalPDFDialog
            open={openPreview}
            onClose={() => setOpenPreview(false)}
          />
        )}

        {selectedProcedure === 'EmbryoTransfer' && (
          <EmbryoTransferPDFDialog
            open={openPreview}
            onClose={() => setOpenPreview(false)}
          />
        )}

        <div style={{ marginTop: '2rem', marginLeft: '2rem' }}>
          {renderProcedureForm}
        </div>
      </div>
    </ThemeProvider>
  );
};

export default SurgeryPage;
